const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.098 7.536C7.134 7.512 9.702 7.5 14.802 7.5H22.434L23.172 9.48C23.292 9.804 23.418 10.152 23.55 10.524C23.694 10.896 23.796 11.172 23.856 11.352C23.916 11.52 23.958 11.64 23.982 11.712H23.622L23.262 11.694C22.998 10.998 22.572 10.392 21.984 9.876C21.408 9.348 20.742 8.964 19.986 8.724C19.326 8.496 18.384 8.34 17.16 8.256C16.8 8.232 14.994 8.22 11.742 8.22C10.11 8.22 9.294 8.226 9.294 8.238C9.33 8.274 10.32 9.63 12.264 12.306C14.208 14.97 15.186 16.314 15.198 16.338C15.27 16.446 15.282 16.536 15.234 16.608L8.682 24.366C9.942 24.378 11.22 24.384 12.516 24.384C13.092 24.384 13.71 24.384 14.37 24.384C15.03 24.384 15.582 24.378 16.026 24.366C16.47 24.366 16.716 24.366 16.764 24.366C18.036 24.318 19.05 24.186 19.806 23.97C21.15 23.586 22.164 22.854 22.848 21.774C22.968 21.582 23.106 21.288 23.262 20.892H23.982C23.802 21.408 23.544 22.176 23.208 23.196C22.872 24.216 22.614 24.978 22.434 25.482L14.802 25.5C9.714 25.5 7.152 25.488 7.116 25.464C7.044 25.44 7.008 25.386 7.008 25.302C7.008 25.266 7.026 25.224 7.062 25.176C7.074 25.152 7.632 24.486 8.736 23.178C9.84 21.87 10.944 20.562 12.048 19.254L13.704 17.292C13.704 17.28 12.588 15.744 10.356 12.684L7.026 8.094L7.008 7.896C7.008 7.704 7.038 7.584 7.098 7.536Z",
  fill: "#1E3F6B"
});

const SvgEquationIntegrals1 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationIntegrals1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-integrals-1.a630f88a.svg";
export { ForwardRef as ReactComponent };